import { apiClient } from "@/lib/apiClient";
import {
  CreatePickupLocationDto,
  UpdatePickupLocationDto,
  FetchPickupLocationsOptions,
} from "@/types/models/pickupLocation";

// Pickup Location CRUD Operations
export const getPickupLocations = async (
  options: FetchPickupLocationsOptions = {},
) => {
  const params: Record<string, string> = {};

  if (options.page) params.page = options.page.toString();
  if (options.page_size) params.page_size = options.page_size.toString();
  if (options.sort_by) params.sort_by = options.sort_by;
  if (options.sort_order) params.sort_order = options.sort_order;
  if (options.is_active !== undefined)
    params.is_active = options.is_active.toString();
  if (options.is_default !== undefined)
    params.is_default = options.is_default.toString();
  if (options.created_after) params.created_after = options.created_after;
  if (options.created_before) params.created_before = options.created_before;

  return await apiClient.getPaginated(
    "/api/v1/admin/:storeId/settings/pickup-locations",
    params,
  );
};

export const getPickupLocationById = async (id: string): Promise<any> => {
  return await apiClient.get(
    `/api/v1/admin/:storeId/settings/pickup-locations/${id}`,
  );
};

export const createPickupLocation = async (
  data: CreatePickupLocationDto,
): Promise<any> => {
  return await apiClient.post(
    "/api/v1/admin/:storeId/settings/pickup-locations",
    data,
  );
};

export const updatePickupLocation = async (
  id: string,
  data: UpdatePickupLocationDto,
): Promise<any> => {
  return await apiClient.put(
    `/api/v1/admin/:storeId/settings/pickup-locations/${id}`,
    data,
  );
};

export const deletePickupLocation = async (id: string): Promise<any> => {
  return await apiClient.delete(
    `/api/v1/admin/:storeId/settings/pickup-locations/${id}`,
  );
};
